import React from "react";
import css from "./MyFirstCpnBlog.module.css";
import {BlogView} from "Components";
import DefiningSection from "./DefiningSection/DefiningSection";
import ProduceViewExample from "./ProduceViewExample/ProduceViewExample";
import ProduceBasketExample from "./ProduceBasketExample/ProduceBasketExample";



export default function MyFirstCpnBlog(){
    return (
        <BlogView className={css.myfirstcpnclog} sections={statics.sections}>
            <DefiningSection/>
            <ProduceViewExample/>
            <ProduceBasketExample/>
        </BlogView>
    )
}

const statics={
    sections:[
        {
            title:"My First Component",
            text:`
                Components play a fundamental role in Front-End development by serving as the building blocks 
                for creating user interfaces (UI). They provide a solid starting point for your journey.
                @With React - for example - you have the ability to combine your markup, CSS, and JavaScript to create custom components.
                These components are reusable UI elements that can enhance your application. 
                @In this guide, we will demonstrate how to create custom components using vritra.
            `,
        },
    ],
}
